<template>
  <div id="baniere">
    <section class="section-shaped my-0 ccc">
      <video autoplay muted loop id="myVideo" class="video">
        <source src="../../../public/img/theme/spot.mp4" type="video/mp4" />
      </video>

      <div class="couverture">
        <div class="shape shape-style-1 shape-dark shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex mt-5">
          <div class="col px-0">
            <div class="row">
              <div class="tete" data-aos="zoom-in-up" data-aos-duration="2000">
                <div class="choc text-center text-white">
                  Agence de marketing
                  <span class="typed-text"> {{ typeValue }}</span>
                  <span class="blinking-cursor">|</span>
                  <span class="cursor" :class="{ typing: typeStatus }"
                    >&nbsp;</span
                  >
                </div>

                <div class="leads text-white mt-4">
                  Publicité à vélo - Activation de marque - Distribution de
                  Flyers et d'objets publicitaire - Porte à Porte - Moving board
                  - Design graphique
                </div>

                <div class="btn-wrapper mt-5 text-center button">
                  <base-button
                    class="mb-3 mb-sm-5 btn-lg"
                    type="yellow"
                    @click="$router.push('contact')"
                  >
                    Demander un devis
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      typeValue: "",
      typeStatus: false,
      displayTextArray: [
        "de Proximité",
        "Produit",
        "Stratégique",
        "Évènementiel",
        "Terrain",
      ],
      typingSpeed: 100,
      erasingSpeed: 100,
      newTextDelay: 2000,
      displayTextArrayIndex: 0,
      charIndex: 0,
    };
  },
  created() {
    this.$ga.enable();
    setTimeout(this.typeText, this.newTextDelay + 200);
  },
  methods: {
    suivant() {
      this.$emit("oga", true);
    },

    typeText() {
      if (
        this.charIndex <
        this.displayTextArray[this.displayTextArrayIndex].length
      ) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue += this.displayTextArray[
          this.displayTextArrayIndex
        ].charAt(this.charIndex);
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      } else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },

    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue = this.displayTextArray[
          this.displayTextArrayIndex
        ].substring(0, this.charIndex - 1);
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      } else {
        this.typeStatus = false;
        this.displayTextArrayIndex += 1;
        if (this.displayTextArrayIndex >= this.displayTextArray.length)
          this.displayTextArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    },
  },
};
</script>
<style>
.video {
  min-height: 900px;
  height: 100%;
}
.ccc {
  background-color: black;
  background-image: url("../../../public/img/theme/woodin/panneau_mobile.jpg");
  /*background-image: url("../../../public/img/theme/equipe.jpg");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.choc {
  font-size: 3.3rem;
  font-weight: bold;
  opacity: inherit;
}
.leads {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-size: 1.1em !important;
}
.couverture {
  /*background-color: #2dce89;*/
  background-color: #41ae95d9;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 100%;
  height: 100%;
}
.tete {
  padding-top: 70px;
}
.btn-lg:hover {
  color: #ffffff;
}
span.typed-text {
  color: #ffce00;
}

span.typed-text:hover {
  color: #000;
}

.blinking-cursor {
  font-size: 6rem;
  color: #2c3e50;
  -webkit-animation: 1s blink step-end infinite;
  -moz-animation: 1s blink step-end infinite;
  -ms-animation: 1s blink step-end infinite;
  -o-animation: 1s blink step-end infinite;
  animation: 1s blink step-end infinite;
}
@keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #ffffff;
  }
}
@-moz-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #f18080;
  }
}
@-webkit-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}
@-ms-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}
@-o-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}
@media screen and (max-width: 700px) {
  .choc {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 2rem;
    font-weight: bold;
    opacity: inherit;
  }
  .button {
    margin-top: 30px;
  }
  .tete {
    padding-top: 0px;
  }
  .video {
    min-height: 400px;
    max-height: 700px;
  }
  .blinking-cursor {
    font-size: 2rem;
  }
}
</style>
